var render = function render(){
  var _vm$billingaccount, _vm$invoice$billed_da, _vm$order$buyer_data, _vm$invoice$order_dat, _vm$saving_invoice_er, _vm$saving_invoice_er2, _vm$saving_invoice_er3, _vm$saving_invoice_er4, _vm$saving_invoice_er5, _vm$saving_invoice_er6, _vm$saving_invoice_er7, _vm$saving_invoice_er8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    staticClass: "invoice-modal general-settings-reference stitch-form",
    attrs: {
      "flat-chrome": "",
      "fill-height": _vm.isSplitLayout,
      "help-content-id": "popup-editcustomerinvoice-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "rawcontent"
  }, [_vm.invoice ? _c('div', {
    staticClass: "customerinvoice-layout",
    "class": {
      'customerinvoice-layout--no-document': !_vm.showDocument
    }
  }, [_vm.showDocument ? _c('div', {
    staticClass: "document d-flex justify-center",
    "class": {
      'document--upload': !_vm.hasFilePreview
    }
  }, [_vm.billingaccount_loading ? [_c('Loading', {
    attrs: {
      "absolute": false
    }
  })] : _vm.isCustomerInvoice && !_vm.billingaccount ? [_c('Placeholder', {
    attrs: {
      "icon": "customer",
      "no-padding": true,
      "title": _vm.$translate('selectCustomer'),
      "description": _vm.$translate('selectCustomerDescription'),
      "actions": _vm.billingaccount ? [{
        text: _vm.$translate('configureBillingaccount'),
        action: 'configure'
      }] : []
    },
    on: {
      "configure": _vm.showBillingAccountSettings
    }
  })] : _vm.isCustomerInvoice && (_vm$billingaccount = _vm.billingaccount) !== null && _vm$billingaccount !== void 0 && _vm$billingaccount.handle_invoices ? [_c('Placeholder', {
    attrs: {
      "icon": "customerinvoice",
      "no-padding": true,
      "title": _vm.$translate('automaticInvoice'),
      "description": _vm.$translate('automaticInvoiceDescription'),
      "actions": [{
        text: _vm.$translate('configureBillingaccount'),
        action: 'configure'
      }]
    },
    on: {
      "configure": _vm.showBillingAccountSettings
    }
  })] : _vm.isCustomerInvoice ? [_c('Placeholder', {
    attrs: {
      "icon": "customerinvoice",
      "no-padding": true,
      "title": _vm.$translate('laterUploadInvoice'),
      "description": _vm.$translate('laterUploadInvoiceDescription'),
      "actions": [{
        text: _vm.$translate('configureBillingaccount'),
        action: 'configure'
      }]
    },
    on: {
      "configure": _vm.showBillingAccountSettings
    }
  })] : _vm.invoice_file_url && !_vm.parsing_invoice ? [_c('iframe', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.invoice_file_url,
      "height": "100%",
      "width": "100%"
    }
  })] : [_c('SelectFile', {
    attrs: {
      "loading": _vm.parsing_invoice,
      "dragText": _vm.$translate('dropInvoice'),
      "placeholder-title": _vm.$translate('placeholderTitle'),
      "placeholder-description": _vm.$translate('placeholderDescription'),
      "placeholder-action-text": _vm.$translate('placeholderActionText'),
      "loading-text": _vm.$translate('parsing')
    },
    on: {
      "input": function input($event) {
        return _vm.invoiceFileSelected($event);
      }
    }
  })]], 2) : _vm._e(), _c('div', {
    staticClass: "invoiceinfos invoice-editor"
  }, [_c('div', {
    staticClass: "stitch-modal stitch-modal--split"
  }, [_c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-file-document-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("invoiceSettings")))])], 1), _c('div', {
    staticClass: "invoice-settings-fields"
  }, [_c('v-select', {
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.credit,
      "error-messages": _vm.getRequiredFieldErrors('credit', _vm.invoice.credit),
      "label": _vm.$translate('creditDebit'),
      "items": [{
        text: _vm.$translate('debit'),
        value: false
      }, {
        text: _vm.$translate('credit'),
        value: true
      }]
    },
    on: {
      "input": function input($event) {
        return _vm.updateCreditType($event);
      }
    }
  }), _vm.order ? _c('dl', {
    staticClass: "invoice-context"
  }, [_c('div', [_c('dt', [_vm._v(" " + _vm._s(_vm.$translate("customer")) + " ")]), _c('dd', [_vm._v(" " + _vm._s(((_vm$invoice$billed_da = _vm.invoice.billed_data) === null || _vm$invoice$billed_da === void 0 ? void 0 : _vm$invoice$billed_da.name) || ((_vm$order$buyer_data = _vm.order.buyer_data) === null || _vm$order$buyer_data === void 0 ? void 0 : _vm$order$buyer_data.name) || "—") + " ")])]), _c('div', [_c('dt', [_vm._v(" " + _vm._s(_vm.$translate("orderOptional")) + " ")]), _c('dd', [_vm._v(" " + _vm._s(((_vm$invoice$order_dat = _vm.invoice.order_data) === null || _vm$invoice$order_dat === void 0 ? void 0 : _vm$invoice$order_dat.order_id) || _vm.order.order_id || "—") + " ")])])]) : _vm._e(), !_vm.order ? _c('SearchCustomer', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.billed,
      "disabled": !!_vm.order,
      "allow-create": true,
      "create-label": _vm.$translate('createCustomer'),
      "error-messages": _vm.getRequiredFieldErrors('billed', _vm.invoice.billed),
      "label": _vm.$translate('customer'),
      "required": ""
    },
    on: {
      "input": _vm.onCustomerInput
    }
  }) : _vm._e(), _vm.isCustomerInvoice ? _c('SearchBillingAccount', {
    key: _vm.invoice.billingaccount,
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.billingaccount,
      "error-messages": _vm.getRequiredFieldErrors('billingaccount', _vm.invoice.billingaccount),
      "label": _vm.$translate('billingAccount'),
      "required": ""
    },
    on: {
      "input": _vm.onBillingAccountInput
    }
  }) : _vm._e(), !_vm.order ? _c('SearchOrder', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "disabled": !!_vm.order || !_vm.invoice.billed,
      "value": _vm.invoice.order,
      "additionalParams": {
        buyer: _vm.invoice.billed
      },
      "error-messages": (_vm$saving_invoice_er = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er === void 0 ? void 0 : _vm$saving_invoice_er.order,
      "label": _vm.$translate('orderOptional')
    },
    on: {
      "input": function input($event) {
        _vm.updateInvoiceData({
          key: 'order',
          value: $event === null || $event === void 0 ? void 0 : $event.id
        });
        _vm.updateInvoiceData({
          key: 'order_data',
          value: $event
        });
      }
    }
  }) : _vm._e(), _c('DateTime', {
    key: "invoice-date=".concat(_vm.invoice.invoice_date),
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.invoice_date,
      "min-date": null,
      "max-date": _vm.invoice.due_date,
      "error-messages": _vm.getRequiredFieldErrors('invoice_date', _vm.invoice.invoice_date),
      "label": _vm.$translate(_vm.invoice.credit ? 'creditNoteDateLabel' : 'invoiceDateLabel'),
      "only-date": true,
      "placeholder": _vm.invoice.invoice_date ? _vm.$translate(_vm.invoice.credit ? 'creditNoteDatePlaceholder' : 'invoiceDatePlaceholder').replace('{date}', _vm.$moment(_vm.invoice.invoice_date).format('LL')) : null
    },
    on: {
      "input": function input($event) {
        return _vm.updateInvoiceDate($event);
      }
    }
  }), !_vm.invoice.credit ? _c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "disabled": !_vm.invoice.invoice_date,
      "value": _vm.payment_delay,
      "error-messages": (_vm$saving_invoice_er2 = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er2 === void 0 ? void 0 : _vm$saving_invoice_er2.payment_delay,
      "label": _vm.$translate('paymentDelays.paymentDelay'),
      "items": _vm.paymentDelays,
      "required": ""
    },
    on: {
      "input": function input($event) {
        return _vm.updatePaymentDelay($event);
      }
    }
  }) : _vm._e(), !_vm.invoice.credit ? _c('DateTime', {
    key: "due-date=".concat(_vm.invoice.due_date),
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.due_date,
      "min-date": _vm.invoice.invoice_date,
      "max-date": null,
      "error-messages": (_vm$saving_invoice_er3 = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er3 === void 0 ? void 0 : _vm$saving_invoice_er3.due_date,
      "label": _vm.$translate('invoiceDueDateLabel'),
      "placeholder": _vm.invoice.due_date ? _vm.$translate('invoiceDueDatePlaceholder').replace('{date}', _vm.$moment(_vm.invoice.due_date).format('LL')) : null,
      "only-date": true
    },
    on: {
      "input": function input($event) {
        return _vm.updateDueDate($event);
      }
    }
  }) : _vm._e(), !_vm.invoice.credit && _vm.isCustomerInvoice ? _c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.payment_method,
      "items": _vm.paymentMethodChoices,
      "label": _vm.$translate('paymentMethod'),
      "error-messages": (_vm$saving_invoice_er4 = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er4 === void 0 ? void 0 : _vm$saving_invoice_er4.payment_method,
      "clearable": ""
    },
    on: {
      "input": _vm.onPaymentMethodChange
    }
  }) : _vm._e(), !_vm.invoice.credit && _vm.isCustomerInvoice && _vm.invoice.payment_method === 'transfer' ? _c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.bank_account,
      "items": _vm.bankAccountChoices,
      "item-text": "text",
      "item-value": "value",
      "label": _vm.$translate('accountToCredit'),
      "error-messages": (_vm$saving_invoice_er5 = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er5 === void 0 ? void 0 : _vm$saving_invoice_er5.bank_account,
      "loading": _vm.invoiceBankAccountsLoading
    },
    on: {
      "input": _vm.onBankAccountInput
    }
  }) : _vm._e(), _vm.missingTransferIban ? _c('p', {
    staticClass: "text-caption mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$translate("noIbanWillBePrinted")) + " ")]) : _vm._e(), _vm.emptyBankAccountList && !_vm.canAddBankAccount ? _c('p', {
    staticClass: "text-caption mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$translate("addIbanOnBillingAccount", {
    name: _vm.billingAccountName
  })) + " ")]) : _vm._e(), _vm.missingCustomerDebitIban ? _c('p', {
    staticClass: "text-caption mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$translate("customerDebitIbanMissing")) + " ")]) : _vm._e(), _vm.isCustomerProviderInvoice ? [_c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoiceIdValue,
      "error-messages": (_vm$saving_invoice_er6 = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er6 === void 0 ? void 0 : _vm$saving_invoice_er6.invoice_id,
      "label": _vm.$translate('invoiceId')
    },
    on: {
      "input": function input($event) {
        return _vm.updateInvoiceData({
          key: 'invoice_id',
          value: $event
        });
      }
    }
  }), _c('div', {
    staticClass: "d-block d-sm-flex mt-4"
  }, [_c('v-text-field', {
    staticClass: "mr-0 mr-sm-3",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.total_amount_excl_vat,
      "error-messages": _vm.getRequiredFieldErrors('total_amount_excl_vat', _vm.invoice.total_amount_excl_vat),
      "label": _vm.$translate('totalExclVat'),
      "append-icon": "€",
      "name": "total_amount_excl_vat",
      "type": "text",
      "inputmode": "decimal",
      "required": ""
    },
    on: {
      "input": function input($event) {
        _vm.updateInvoiceData({
          key: 'total_amount_excl_vat',
          value: parseFloat(_vm.$utils.normalizeDecimalString($event))
        });
      }
    }
  }), _c('v-text-field', {
    staticClass: "ml-0 ml-sm-3",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.total_vat_amount,
      "error-messages": _vm.getRequiredFieldErrors('total_vat_amount', _vm.invoice.total_vat_amount),
      "label": _vm.$translate('totalVat'),
      "append-icon": "€",
      "name": "total_vat_amount",
      "type": "text",
      "inputmode": "decimal",
      "required": ""
    },
    on: {
      "input": function input($event) {
        _vm.updateInvoiceData({
          key: 'total_vat_amount',
          value: parseFloat(_vm.$utils.normalizeDecimalString($event))
        });
      }
    }
  })], 1), _c('div', {
    staticClass: "invoice-total"
  }, [_c('span', [_vm._v(_vm._s(_vm.$translate("totalInclVat")))]), _c('strong', [_vm._v(_vm._s(_vm.formatInvoiceAmount(_vm.invoice.total_amount_incl_vat || 0)))])]), _c('v-messages', {
    staticClass: "error--text",
    attrs: {
      "value": [].concat(((_vm$saving_invoice_er7 = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er7 === void 0 ? void 0 : _vm$saving_invoice_er7.total_amount_incl_vat) || [])
    }
  })] : _vm._e(), _vm.isCustomerInvoice ? _c('v-textarea', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto",
      "dense": "",
      "outlined": "",
      "value": _vm.invoice.notes,
      "error-messages": (_vm$saving_invoice_er8 = _vm.saving_invoice_errors) === null || _vm$saving_invoice_er8 === void 0 ? void 0 : _vm$saving_invoice_er8.notes,
      "label": _vm.$translate('notes'),
      "placeholder": _vm.$translate('notesPlaceholder')
    },
    on: {
      "input": function input($event) {
        return _vm.updateInvoiceData({
          key: 'notes',
          value: $event
        });
      }
    }
  }) : _vm._e()], 2)])], 1)], 1)])]) : _vm._e()]), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('cancel'),
      "ghost": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.isNew ? _vm.$translate('create') : _vm.$translate('save'),
      "disabled": !_vm.canSaveInvoice(),
      "loading": _vm.saving_invoice
    },
    on: {
      "click": _vm.saveInvoiceClicked
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }